import React, { useState } from "react";
import { Box, Button, Typography, Paper, Stack, Snackbar, Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { useBrokerPayments } from "services/hooks/rentals";
import PaymentsTable from "components/Tables/BrokerPaymentsTable";

const BrokerPayments = () => {
  const role = useSelector((state) => state.role);
  const broker = useSelector((state) => state.broker);
  const isBroker = role === "broker";
  const isStaff = role === "admin" || role === "manager";

  const brokerIdForQuery = isBroker ? undefined : broker?.id;
  const { brokerPayments, isLoadingBrokerPayments, errorBrokerPayments } = useBrokerPayments(brokerIdForQuery);

  if (!isBroker && !isStaff) {
    return (
      <Box m={2}>
        <Alert severity="warning">You do not have access to broker payments.</Alert>
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          {isBroker ? "My Payment History" : "Broker Payments"}
        </Typography>
      </Stack>

      {isBroker && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Payouts recorded by admin against your commission balance.
        </Typography>
      )}

      {errorBrokerPayments && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Failed to load payment history.
        </Alert>
      )}

      <PaymentsTable
        payments={brokerPayments}
        broker={broker}
        isLoading={isLoadingBrokerPayments}
        readOnly={isBroker}
      />
    </Box>
  );
};

export default BrokerPayments;
